import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';

import { Buffer } from 'buffer';

Vue.use(Vant);

Vue.config.productionTip = false
 
window.Buffer = Buffer;

new Vue({
  render: h => h(App),
}).$mount('#app')
